import PageCommon from "../../pages/PageCommon";
import WrapperIO from "../../pages/SolrTest/utils/WrapperIO";
import Dialog from "./abstract/AbstractDialog";

export default class DialogLoadQuery extends Dialog {
  constructor(template, callback = null) {
    super(template, callback);
  }

  init(queries) {
    super.init();
    // crea le entries
    const a = queries;
    for (let x = 0; x < a.length; x++) {
      const entry = jQuery("#template-load-single-query").clone();
      entry.removeAttr("id");
      // entry.text(a[x].name);
      $("h3", entry).text(a[x].Name);
      //entry.on("click", this.onEntryClick.bind(this, a[x]));
      entry.on("click", this.onEntryClick.bind(this, entry, a[x]));
      this.dialog.querySelector(".js-queries").appendChild(entry[0]);
    }
    const btnConfirm = this.dialog.querySelector(".js-btn-confirm");
    btnConfirm.classList.add("is-disabled");
    const btnDelete = this.dialog.querySelector(".js-btn-delete");
    btnDelete.classList.add("is-disabled");
    btnDelete.addEventListener("click", (e) => {
      this.onDelete(e);
    });
  }

  onEntryClick(entry, query, event) {
    this.entrySelected = query;
    jQuery(".js-queries .selected", this.dialog).removeClass("selected");
    //jQuery(event.target).addClass("selected");
    entry.addClass("selected");
    const btnConfirm = this.dialog.querySelector(".js-btn-confirm");
    btnConfirm.classList.remove("is-disabled");
    const btnDelete = this.dialog.querySelector(".js-btn-delete");
    btnDelete.classList.remove("is-disabled");
    this.dialog.querySelector(".js-query-desc").innerHTML = query.Description ? query.Description : "";
  }

  onDelete(e) {
    PageCommon.that.showPreloader(true);
    WrapperIO.deleteQuery(this.entrySelected.Uid, this.handleDeleteEvent.bind(this));
  }

  handleDeleteEvent(newQueries) {
    this.dialog.querySelector(".js-queries").innerHTML = "";
    this.dialog.querySelector(".js-query-desc").innerHTML = "";
    PageCommon.that.showPreloader(false);
    if (newQueries.length === 0) {
      this.hide();
      this.callback?.call(null, null);
    } else {
      this.init(newQueries.queries);
    }
  }

  onConfirm(e) {
    e.preventDefault();
    this.hide();
    this.callback?.call(null, this.entrySelected);

    //const field = this.dialog.querySelector(".js-input-text");
    //const value = field.value;
    /*if (value.length < 3) {
      field.classList.add("has-error");
    } else {
      field.classList.remove("has-error");
      this.hide();
      this.callback?.call(null, value);
    }*/
  }

  onDismiss(e) {
    e.preventDefault();
    this.hide();
    this.callback?.call(null, null);
  }
}
